// Lightweight WebAudio SFX + haptics — no audio assets needed.
let _ctx;
function ctx() {
  try {
    _ctx = _ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (_ctx.state === "suspended") _ctx.resume();
    return _ctx;
  } catch (e) { return null; }
}

export function isMuted() {
  try { return localStorage.getItem("dig_muted") === "1"; } catch (e) { return false; }
}
export function setMuted(v) {
  try { localStorage.setItem("dig_muted", v ? "1" : "0"); } catch (e) {}
}

export function haptic(pattern = 12) {
  if (isMuted()) return;
  try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (e) {}
}

// Soft card flip: a quick descending sine blip.
export function playFlip() {
  if (isMuted()) return;
  const a = ctx();
  if (a) {
    try {
      const o = a.createOscillator(), g = a.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(560, a.currentTime);
      o.frequency.exponentialRampToValueAtTime(190, a.currentTime + 0.12);
      g.gain.setValueAtTime(0.0001, a.currentTime);
      g.gain.exponentialRampToValueAtTime(0.14, a.currentTime + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + 0.15);
      o.connect(g).connect(a.destination);
      o.start(); o.stop(a.currentTime + 0.16);
    } catch (e) {}
  }
  haptic(14);
}

// Soft shuffle: a short flurry of soft ticks (riffle).
export function playShuffle() {
  if (isMuted()) return;
  const a = ctx();
  if (a) {
    try {
      for (let i = 0; i < 8; i++) {
        const t = a.currentTime + i * 0.045;
        const o = a.createOscillator(), g = a.createGain();
        o.type = "triangle";
        o.frequency.setValueAtTime(280 + Math.random() * 420, t);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.06, t + 0.008);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.05);
        o.connect(g).connect(a.destination);
        o.start(t); o.stop(t + 0.055);
      }
    } catch (e) {}
  }
  haptic([10, 24, 10, 24, 12]);
}
